import React from "react";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import { goToReportPage, queryParamsToProps } from "./services/queryParams";
import { useRouter } from "Hooks/useRouter";
import {
  DateRangeInput,
  GetRewardsQuery,
  GetRewardsQueryVariables,
} from "generated/graphql";
import { RewardStatus } from "Shared/types/Rewards";

export const REWARDS_PER_PAGE = 10;

export const useRewards = () => {
  const { history, location } = useRouter();
  const { page, beginDate, endDate, rewarderId, status } = queryParamsToProps(location.search);

  const createdAtBetween = beginDate && endDate
    ? {
      beginDate,
      endDate,
    }
    : undefined;

  const { data, loading } = useQuery<GetRewardsQuery, GetRewardsQueryVariables>(queries.GET_REWARDS, {
    variables: {
      page,
      perPage: REWARDS_PER_PAGE,
      createdAtBetween,
      requesterId: rewarderId,
      statuses: [status],
    },
  });

  const onChangePage = (
    evt: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => goToReportPage(history, {
    page: newPage,
    beginDate,
    endDate,
    rewarderId,
    status,
  });

  const onChangeDateRange = (
    range: DateRangeInput
  ) => goToReportPage(history, {
    page: 1,
    beginDate: range.beginDate,
    endDate: range.endDate,
    rewarderId,
    status,
  });

  const onChangeRewarder = (
    newRewarderId: string
  ) => goToReportPage(history, {
    page: 1,
    beginDate,
    endDate,
    rewarderId: newRewarderId,
    status,
  });

  const onChangeStatus = (
    newStatus?: RewardStatus
  ) => goToReportPage(history, {
    page: 1,
    beginDate,
    endDate,
    rewarderId,
    status: newStatus,
  });

  return {
    rewards: data?.employer.currentProvider.rewards,
    loading,
    page,
    rowsPerPage: REWARDS_PER_PAGE,
    onChangePage,
    beginDate,
    endDate,
    onChangeDateRange,
    rewarderId,
    onChangeRewarder,
    status,
    onChangeStatus,
  };
};
